<script setup lang="ts">
import { ref } from "vue";
import { t } from "@/services/i18n";

const props = defineProps({
    value: {
        type: String,
        default: "",
        required: false,
    },
    placeholder: {
        type: String,
        default: "",
        required: false,
    },
});

const emit = defineEmits(["onTextInput", "onLeaveInput"]);
const modelValue = ref(props.value);

function leaveInput() {
    emit("onLeaveInput");
}

function updateValue(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    emit("onTextInput", inputElement.value);
}
</script>
<template>
    <input
        type="text"
        v-model="modelValue"
        :placeholder="t(placeholder)"
        :class="{ 'is-active': modelValue }"
        @input="updateValue($event)"
        @blur="leaveInput()"
    />
</template>
